import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { useSelector } from "react-redux";

const IDVerification = () => {
  const translation = useSelector(state => state.root.translation);
  const route = all_routes;
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    name: "",
    idNumber: "",
    frontId: null,
    backId: null,
  });

  const [errors, setErrors] = useState({
    name: "",
    idNumber: "",
    frontId: "",
    backId: "",
  });

  const handleInputChange = (e) => {

    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors(prevErrors => ({ ...prevErrors, [name]: false }));
  };

  // const handleFileChange = (e) => {
  //   const { name, files } = e.target;
  //   setFormData({ ...formData, [name]: files[0] });
  // };
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

    if (file && !validImageTypes.includes(file.type)) {
        setErrors(prevErrors => ({ ...prevErrors, [name]: "Only image files are allowed" }));
        
    } else if (file && file.size > 2 * 1024 * 1024) {
        setErrors(prevErrors => ({ ...prevErrors, [name]: "File size must be less than 2MB" }));
    } else {
        setFormData({ ...formData, [name]: file });
        // let name = await uploadImage(event.target.files[0])
        setErrors(prevErrors => ({ ...prevErrors, [name]: "" }));
    }
  };


  const validate = () => {
    const newErrors = {};

    if (!formData.name) newErrors.name = translation['err_name_card'];
    if (!formData.idNumber) newErrors.idNumber =  translation['err_id_cardnumber'];
    if (!formData.frontId) newErrors.frontId =  translation['err_front'];
    if (!formData.backId) newErrors.backId =  translation['err_back'];

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      const previousformData = location.state;

      previousformData.idCardVerification = {
        name: formData.name,
        idNumber: formData.idNumber,
        frontId:"https://as1.ftcdn.net/v2/jpg/03/66/51/86/1000_F_366518642_U0OHJksfJB1dQGYXExpoAeRIDH8EbWYv.jpg",//formData.frontId,
        backId:"https://as1.ftcdn.net/v2/jpg/03/66/51/86/1000_F_366518642_U0OHJksfJB1dQGYXExpoAeRIDH8EbWYv.jpg"//formData.backId
      };
      console.log(previousformData);

      navigate(route.subscriptionplan, { state: previousformData });
    }
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper">
          <div className="login-img">
            <ImageWithBasePath src="assets/img/authentication/login02.png" alt="img" />
          </div>
          
          <div className="login-content">
            <form onSubmit={handleSubmit} style={{ width: '80%' }}>
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt="img" />
                </Link>
                <div className="login-userheading">
                <h3>{translation?.profile} -{">"} {translation?.store_address} -{">"} {translation?.id_verification}</h3>

                </div>
                <div className="form-login">
                  <label>{translation?.Name_on_card}</label>
                  <div className="form-addons">
                    <input
                      type="text"
                      name="name"
                      maxLength={30}
                      value={formData.name}
                      onChange={handleInputChange}
                      className="form-control"
                    />
                    <ImageWithBasePath src="assets/img/icons/user-icon.svg" alt="img" />
                  </div>
                  
                  {errors.name && <p className="text-danger">{errors.name}</p>}
                </div>
                <div className="form-login">
                  <label>{translation?.id_card_number}</label>
                  <div className="form-addons">
                    <input
                      type="text"
                      maxLength={13}
                      name="idNumber"
                      value={formData.idNumber}
                      onChange={handleInputChange}
                      className="form-control"
                    />
                    <ImageWithBasePath src="assets/img/icons/mail.svg" alt="img" />
                  </div>
                  {errors.idNumber && <p className="text-danger">{errors.idNumber}</p>}
                </div>

                <div className="form-login">
                  <label>{translation?.upload_front}</label>
                  <div className="form-addons">
                    <input
                      type="file"
                      name="frontId"
                      onChange={handleFileChange}
                      className="form-control"
                    />
                    {/* <ImageWithBasePath src="assets/img/icons/upload.svg" alt="img" /> */}
                  </div>
                  {errors.frontId && <p className="text-danger">{errors.frontId}</p>}
                </div>

                <div className="form-login">
                  <label>{translation?.upload_back}</label>
                  <div className="form-addons">
                    <input
                      type="file"
                      name="backId"
                      onChange={handleFileChange}
                      className="form-control"
                    />
                    {/* <ImageWithBasePath src="assets/img/icons/upload.svg" alt="img" /> */}
                  </div>
                  {errors.backId && <p className="text-danger">{errors.backId}</p>}
                </div>

                <div className="form-login">
                  <button type="submit" className="btn btn-login">
                  {translation?.next_btn}
                  </button>
                </div>

                <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                  <p>{translation?.copyright_message}</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IDVerification;